		<div ngbDropdown #myDropdown="ngbDropdown" [placement]="['bottom-start', 'top-start']" class="d-inline-block w-100" style="height: 45.2px;">
			<button type="button" class="btn font-10 p-r-12 custom-select position-relative align-items-center justify-content-between w-100 h-100" id="dropdownBasic1" style="display: flex;overflow: hidden;" ngbDropdownToggle>
        <app-svg iconType="UndoSVG" *ngIf="selctedValue?.name"  (click)="selectedData('')" class="svgIcon p-l-9px">
        </app-svg>
        <span *ngIf="importCodecrosswalk" class="text-truncate code template-name" [ngClass]="{'text-gray': !selctedValue?.name,'text-primary-color': selctedValue?.name}">{{ selctedValue?.name || selectLabel }}</span>
        <span *ngIf="!importCodecrosswalk" class="text-truncate template-name" [ngClass]="{'text-gray': !selctedValue?.name,'text-primary-color': selctedValue?.name}">{{selctedValue?.name || selectLabel }} </span>
        <span>
          <app-svg iconType="BigDownArrow" *ngIf="myDropdown?.isOpen()">
          </app-svg>
          <app-svg iconType="BigUpArrow" *ngIf="!myDropdown?.isOpen()">
          </app-svg> 
        </span>
			</button>
			<div ngbDropdownMenu class="p-0 dropDown_menu" aria-labelledby="dropdownBasic1">
        <ng-container *ngIf="options && options.length > 0; else noRecords">
         <button class="font-12" (click)="selectedData(item)" *ngFor="let item of options; let index = index" ngbDropdownItem > 
          <div class="d-flex justify-content-between">
            <p class="text-truncate m-0 p-0" >{{item.name}} </p>
            <span>
            <app-svg iconType="Delete" (click)="deleteOption($event, item.id, item.name)">
            </app-svg>
          </span>
          </div>
         </button>
        </ng-container>
       <ng-template #noRecords>
         <div class="dropdown-item text-gray text-truncate font-12 notAllowed">No records available
         </div>
       </ng-template>
			</div>
